import { defineComponent, h, createVNode, Static } from "vue";
import { SPRITE_PATHS } from "#nuxt-svg-sprite/runtime";
import { ALL_SYMBOL_DOMS } from "#nuxt-svg-sprite/data";
export default defineComponent({
  props: {
    name: String,
    noWrapper: Boolean,
    inline: Boolean
  },
  setup(props) {
    return () => {
      const [sprite, name] = (props.name || "").split("/");
      const symbolKey = name || sprite;
      if (props.inline) {
        if (props.noWrapper) {
          return createVNode(Static, {}, ALL_SYMBOL_DOMS[symbolKey]?.dom);
        }
        const attributes = ALL_SYMBOL_DOMS[symbolKey]?.attributes || {};
        attributes.id = null;
        return h(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            "data-symbol": name || sprite,
            ...attributes,
            innerHTML: ALL_SYMBOL_DOMS[symbolKey]?.dom,
            id: null
          }
        );
      }
      const symbolDom = h("use", {
        href: SPRITE_PATHS[name ? sprite : "default"] + "#" + (name || sprite)
      });
      return props.noWrapper ? symbolDom : h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          "data-symbol": name || sprite
        },
        symbolDom
      );
    };
  }
});
if (import.meta.hot) {
  import.meta.hot.accept(() => {
  });
}
